import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModuleGeneralPractice from '../../schemas/module-general-practice.json';

export class SchemaModuleGeneralPractice extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleGeneralPractice );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-general-practice.ts